import { HomeTab } from '../../../../components/HomeTabTitle'
import { Avatar, Box } from '@material-ui/core'
import { accountsLogoSwitcher } from '../../../shared/lib/accountLogoSwitcher'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { IntegrationType } from '../../../../server/mpsklad_core/Entity/IntegrationType'
import { appRoutes } from '../../../../common/appRoutes'
import { integrationKeyByType } from '../../../../types/integrationTypeUtils'
import { useHistory, useLocation } from 'react-router-dom'
import clsx from 'clsx'
import { useStore } from '../../../../hooks/storeHook'
import { observer } from 'mobx-react-lite'

export type MarketplaceTabProps = {
  account: HomeTab
}

export const MarketplaceTab = observer(({account}: MarketplaceTabProps) => {
  const history = useHistory()
  const {pathname} = useLocation()
  const classes = useStyles()
  const {setHomeNav} = useStore()

  const getAccountPath = () => {
    if (account.integrationType === IntegrationType.MoySklad) {
      return appRoutes.Store.settings.makeUrl({integration: 'MoySklad', accountId: 0})
    }
    return appRoutes.Store.settings.makeUrl({
      integration: integrationKeyByType[account.integrationType],
      accountId: account.id
    })
  }

  const isActive = pathname === getAccountPath()

  const handleRedirect = () => {
    setHomeNav(account.integrationType, account.id)
    history.push(getAccountPath())
  }

  return (
    <Box className={clsx(classes.wrapper, {
      [classes.active]: isActive
    })} onClick={handleRedirect}>
      <Avatar
        src={accountsLogoSwitcher(account.integrationType)}
        alt={account.title}
        className={classes.img}
        variant={'square'}
      />
      <span className={classes.title}>{account.title}</span>
    </Box>
  )
})

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      overflow: 'hidden',
      position: 'relative',
      fontSize: '0.875rem',
      maxWidth: '264px',
      boxSizing: 'border-box',
      minHeight: '48px',
      textAlign: 'center',
      flexShrink: 0,
      fontFamily: 'Gilroy, Arial, sans-serif',
      fontWeight: 500,
      lineHeight: 1.75,
      whiteSpace: 'normal',
      textTransform: 'uppercase',
      opacity: '0.7'
    },
    active: {
      opacity: 1
    },
    title: {
      color: '#727272',
      fontSize: 12
    },
    img: {
      width: 12,
      height: 12,
      transition: 'transform 0.3s ease-in-out'
    },
    animated: {
      '&:hover': {
        animation: '$spin 1s linear infinite'
      }
    },
    '@keyframes spin': {
      from: {transform: 'rotate(0deg)'},
      to: {transform: 'rotate(360deg)'}
    }
  })
)